<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Situação de cartões Elo</span>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div (click)="exportExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="exportPdf()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar PDF</span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filtroOn" (click)="deleteFilter()" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(modalfiltro)" class="list-select ml-2 my-1">
                                <button class="list-select"  type="button">
                                    <span><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                    <!-- <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span> -->
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <span  class="d-flex justify-content-end clean-modal-text my-2" style="font-size:small;">Data da consulta: {{ queryDate | date: "dd/MM/yyyy HH:mm:ss" }}</span>
            
            <div class="row">
                <div class="col-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li class="mr-3" *ngIf="filtroOn && filtro.dateInclusion"><b>Data inicio: </b>{{ filtro.dateInclusion | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.pan"><b>Final do cartão: </b>{{ filtro.pan }}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.status"><b>Stauts: </b>{{ filtro.status==1 ? 'Ativo' : filtro.status==2 ? 'Temporário' : 'Definitivo' }}</li>
                        
                    </ul>
                </div>
            </div>  

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>Favorecido</th>
                            <th>Número do cartão</th>
                            <th>Inclusão</th>
                            <th>Validade</th>
                            <th>Vínculo</th>
                            <th>Bloqueio</th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of cards | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'cardStatus' }">
                                <td>{{ item.collaborator }}</td>                              
                                <td>{{ item.pan }}</td> 
                                <td>{{ item.inclusionDate | date: "dd/MM/yyyy" }}</td>
                                <td>{{ item.expirationDate }}</td>    
                                <td>{{ item.linked ? 'Vinculado' : 'Não Vinculado' }}</td>                                       
                                <td>
                                    <ng-container *ngIf="item.linked">
                                        <span *ngIf="item.definitive">Definitivo</span>
                                        <span *ngIf="item.actived && !item.definitive">Ativo</span>
                                        <span *ngIf="!item.actived && !item.definitive">Temporário</span>
                                    </ng-container>
                                    <span *ngIf="!item.linked">-</span>
                                </td>                    
                            </tr>
                        </tbody>
                    </table>
                    
                    <div *ngIf="!cards || cards == [] || cards.length == 0" class="text-center">
                            Nenhum registro carregado. Aplique o filtro para retornar a lista com registros
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="cardStatus" (pageChange)="carregarRelatorio($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #modalfiltro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input [formControl]="incDateCtrl" id="incDate" matInput [matDatepicker]="incDate" placeholder="Data de Inclusão" [value]="filtro.dateStart"/>
                    <mat-datepicker-toggle matSuffix [for]="incDate"></mat-datepicker-toggle>
                    <mat-datepicker #incDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Final do cartão</mat-label>
                    <input [formControl]="panCtrl" [textMask]="{mask: panMask}" matInput type="text" id="value">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Situação</mat-label>
                    <mat-select [formControl]="statusCtrl" placeholder="Selecione...">
                        <mat-option>Nenhum</mat-option>
                        <mat-option value="1">Ativo</mat-option>
                        <mat-option value="2">Temporário</mat-option>
                        <mat-option value="3">Definitivo</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>